
import React from 'react';
import { useState } from 'react';
import { FiMail, FiPhone, FiMapPin, FiSend, FiUser, FiMessageSquare } from 'react-icons/fi';
import  Chatbot  from '../../components/ui/chatbot';
const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }
    if (!formData.message.trim()) newErrors.message = 'Message is required';
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      // Here you would typically send the data to your backend
      console.log('Form submitted:', formData);
      setSubmitted(true);
      setFormData({ name: '', email: '', message: '' });
      setTimeout(() => setSubmitted(false), 3000);
    }
  };

  return (
<div className="pt-24 pb-24 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-purple-900 via-sky-200 to-blue-900 ">
  <div className="max-w-7xl mx-auto">
    {/* Title */}
    <div className="text-center mb-16">
      <h1 className="text-4xl font-extrabold text-gray-900 sm:text-5xl lg:text-6xl mb-4">
        Contact <span className="text-yellow-600">Us</span>
      </h1>
      <p className="text-lg sm:text-xl text-gray-600 max-w-2xl mx-auto text-yellow-900">
        Have questions or want to collaborate? We’d love to hear from you.
      </p>
    </div>

    {/* Contact Card */}
    <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-purple-100">
      <div className="grid md:grid-cols-3">
        
        {/* Contact Info */}
        <div className="bg-gradient-to-b from-purple-600 to-purple-900 p-10 text-white flex flex-col justify-between">
          <div>
            <h2 className="text-2xl font-bold mb-8">Get in Touch</h2>
            <ul className="space-y-6">
              <li className="flex items-start">
                <div className="p-3 rounded-full bg-white/20 mr-4 flex items-center justify-center">
                  <FiMail size={20} className="text-white" />
                </div>
                <div>
                  <h3 className="font-semibold">Email</h3>
                  <p className="text-purple-100">contact@example.com</p>
                </div>
              </li>
              <li className="flex items-start">
                <div className="p-3 rounded-full bg-white/20 mr-4 flex items-center justify-center">
                  <FiPhone size={20} className="text-white" />
                </div>
                <div>
                  <h3 className="font-semibold">Phone</h3>
                  <p className="text-purple-100">+1 (555) 123-4567</p>
                </div>
              </li>
              <li className="flex items-start">
                <div className="p-3 rounded-full bg-white/20 mr-4 flex items-center justify-center">
                  <FiMapPin size={20} className="text-white" />
                </div>
                <div>
                  <h3 className="font-semibold">Address</h3>
                  <p className="text-purple-100">123 Business Ave, Suite 400<br />San Francisco, CA 94107</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Social Links */}
          <div className="mt-12">

          </div>
        </div>

        {/* Contact Form */}
        <div className="md:col-span-2 p-10 md:p-14">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Send us a message</h2>
          <form className="space-y-6">
            {/* Name */}
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">Name</label>
              <div className="relative">
                <FiUser className="absolute top-3 left-3 text-purple-500" />
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Your name"
                  className="w-full pl-10 pr-3 py-3 border border-purple-200 rounded-lg shadow-sm focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition"
                />
              </div>
            </div>

            {/* Email */}
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">Email</label>
              <div className="relative">
                <FiMail className="absolute top-3 left-3 text-purple-500" />
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="you@example.com"
                  className="w-full pl-10 pr-3 py-3 border border-purple-200 rounded-lg shadow-sm focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition"
                />
              </div>
            </div>

            {/* Message */}
            <div>
              <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">Message</label>
              <div className="relative">
                <FiMessageSquare className="absolute top-3 left-3 text-purple-500" />
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  placeholder="Write your message..."
                  className="w-full pl-10 pr-3 py-3 border border-purple-200 rounded-lg shadow-sm focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition"
                />
              </div>
            </div>

            {/* Button */}
            <div>
              <button
                type="submit"
                className="w-full flex justify-center items-center py-3 px-4 rounded-lg text-white font-medium bg-gradient-to-r from-purple-500 to-purple-900 hover:opacity-90 shadow-lg transition-all"
              >
                <FiSend className="mr-2" /> Send Message
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <Chatbot />
</div>


  );
};

export default Contact;